// Unified dispatch for both right-click and long-press (see the plan's "Behavior change" note):
// try the event menu first, fall back to the cell menu only when there's no event under the
// pointer or its menu is empty. No match on either -> no menu and returns false, so the caller can
// leave the browser's native context menu alone.

import { buildCellMenu } from './cell-menu';
import { buildEventMenu } from './event-menu';
import { openMenu } from './menu';

function canUndo(): boolean {
  return document.querySelector('#calendar table[data-can-undo="1"]') !== null;
}

export function dispatch(x: number, y: number, target: Element): boolean {
  const eventEl = target.closest<HTMLElement>('.event');
  if (eventEl) {
    const items = buildEventMenu(eventEl);
    if (items) {
      openMenu({ x, y, items, returnFocusTo: eventEl });
      return true;
    }
  }
  const cell = target.closest<HTMLElement>('td.editable');
  if (cell) {
    openMenu({ x, y, items: buildCellMenu(cell, canUndo()), returnFocusTo: cell });
    return true;
  }
  return false;
}
